import Vue from 'vue'
import App from './App.vue'

import './assets/common.less'
import './assets/fonts/iconfont.css'
import dataV from '@jiaminghi/data-view'
import axios from 'axios'

Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.use(dataV)

new Vue({
  render: h => h(App)
}).$mount('#app')
